import Axios from 'axios'
import { apiUrls, getParams, setAuthorizationHeaders, setHeaders } from '../utils'
import { getCoordinates } from '@/utils/getLatestLocation'

const { coreBaseUrl } = apiUrls

interface LocalitiesApiResponse<T = any> {
  data: T
  status: number
  statusText: string
  headers: any
  config: any
}

interface LocalitiesApis {
  getLocalities: (params?: Record<string, any>) => Promise<LocalitiesApiResponse>
  getLocalityStores: (params?: Record<string, any>) => Promise<LocalitiesApiResponse>
}

const { latitude, longitude } = getCoordinates()

const localitiesApis: LocalitiesApis = {
  getLocalities: async (params = {}) => {
    const localitiesUrl = `${coreBaseUrl}v1/store/store-locality-counts`
    return await Axios({
      url: localitiesUrl,
      method: 'GET',
      headers: setHeaders(setAuthorizationHeaders()),
      params: getParams({
        ...params,
        latitude,
        longitude
      })
    })
  },

  getLocalityStores: async (params = {}) => {
    const localityStoresUrl = `${coreBaseUrl}v1/store/store-counts`
    return await Axios({
      url: localityStoresUrl,
      method: 'GET',
      headers: setHeaders(setAuthorizationHeaders()),
      params: getParams({
        ...params,
        latitude,
        longitude
      })
    })
  }
}

export default localitiesApis
